import { Box } from '@rexlabs/box';
import { styled, StyleSheet } from '@rexlabs/styling';
import React from 'react';

import { cropText } from './shared/utils';

import GoogleIconChevron from 'src/assets/ad-previews/google/icon-chevron.svg';
import GoogleIconInfo from 'src/assets/ad-previews/google/icon-info.svg';

const defaultStyles = StyleSheet({
  container: {
    width: '30rem',
    height: '25rem',
    background: 'white',
    position: 'relative',
    border: '.1rem solid #e5e5e5',
    fontFamily: 'Roboto, Arial'
  },

  info: {
    position: 'absolute',
    top: 0,
    right: 0,
    background: 'white',
    color: '#00aecd',
    width: '1.8rem',
    height: '1.8rem'
  },

  image: {
    height: '15.7rem',
    width: '100%',
    background: 'grey no-repeat center center',
    backgroundSize: 'cover',
    position: 'relative',
    overflow: 'hidden'
  },

  heading: {
    padding: '.4rem 1.2rem',
    background: 'rgba(243, 243, 243, 1)',
    fontWeight: 700,
    fontSize: '1.8rem'
  },

  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },

  description: {
    padding: '.6rem 1.2rem',
    fontSize: '1rem',
    lineHeight: '1.2',
    fontWeight: 300
  },

  name: {
    padding: '0 1.2rem .6rem',
    fontSize: '1rem',
    lineHeight: '1.2',
    fontWeight: 300
  },

  wrapChevron: {
    width: '4rem',
    height: '4rem',
    boxShadow:
      '0 0 .2rem 0 rgba(0, 0, 0, 0.12), 0 .2rem .2rem 0 rgba(0, 0, 0, 0.24)',
    borderRadius: '4rem',
    marginRight: '1.2rem',
    color: '#919191'
  },

  chevronSvg: {
    height: '1.9rem',
    width: 'auto'
  }
});

const AdWordsStandardPreview = (props) => {
  const { styles: s, campaignData, ad } = props;
  const isMultiListingSold = ['multi_listing_sold', 'multi_listing_let'].includes(
    campaignData.type
  );
  const slide =
    campaignData.slides.find((s) => s.id === ad?.attributes?.slide_id) || {};

  let imageUrl;
  let imageCrop;
  let title;
  let headline;
  const headlineLength = 90;
  if (isMultiListingSold) {
    const image = campaignData.images.find((i) => i.id === slide?.image?.id);

    imageUrl = image?.sizes?.['crop.landscape']?.url;
    imageCrop = Object.values(image?.crops?.landscape?.top_left ?? {}).join();
    title = slide.small_text;
    headline = cropText(slide.short_headline, headlineLength);
  } else {
    const isAgent = campaignData.type === 'agent_profile';

    const format = ad?.format?.id ?? '';
    const isSecondary = format.includes('responsive_secondary');

    const imageKey = isAgent
      ? 'agentImage'
      : isSecondary
      ? 'secondaryImage'
      : 'primaryImage';

    imageUrl = campaignData?.[imageKey]?.landscape;
    title = campaignData.title;
    headline = cropText(campaignData.headline, headlineLength);
  }

  return (
    <Box {...s('container')} flexDirection='column'>
      <Box {...s('info')} justifyContent='center' alignItems='center'>
        <GoogleIconInfo {...s('infoSvg')} />
      </Box>
      <Box
        key={imageCrop}
        {...s.with('image')({
          backgroundImage: imageUrl ? `url(${imageUrl})` : 'none'
        })}
      />
      <Box {...s('heading', 'truncate')}>{title}</Box>
      <Box {...s('wrapText')} flexDirection='row' alignItems='center' flex={1}>
        <Box {...s('text')} flex={1} flexDirection='column'>
          <span {...s('description')}>{headline}</span>
          <span {...s('name')}>{campaignData.agency}</span>
        </Box>
        <Box {...s('wrapChevron')} alignItems='center' justifyContent='center'>
          <GoogleIconChevron {...s('chevronSvg')} />
        </Box>
      </Box>
    </Box>
  );
};

export default styled(defaultStyles)(AdWordsStandardPreview);
